/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInChatListItemManualClassification = typeof LinkedInChatListItemManualClassification[keyof typeof LinkedInChatListItemManualClassification] | null;


export const LinkedInChatListItemManualClassification = {
  interested: 'interested',
  not_interested: 'not_interested',
  out_of_office: 'out_of_office',
} as const;
